import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/README.md?raw';

const SentryIntroduction: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default SentryIntroduction;
